module.exports = __webpack_public_path__ + "img/top BT (2).95df4994.png";